module.exports = __webpack_public_path__ + "static/media/clearance.3bd3fe72.svg";